import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";

const { Customer } = Mobi2Go;

const BurnRules = () => {
    const [t] = useTranslation('loyalty');
    const [burnRules, setBurnRules] = useState();
    let isMounted = true;

    useEffect(() => {
        const updateState = () => {
            if (isMounted) {
                setBurnRules(Customer.getLoyalty('SpoonityLoyalty')?.state?.vendor_perks)
            }
        }
        Customer.bind({
            logIn: updateState,
            update: updateState,
            updateLoyalty: updateState,
        });
        updateState();
        return () => {
            isMounted = false;
            Customer.unbind({
                logIn: updateState,
                update: updateState,
                updateLoyalty: updateState,
            });
        };
    }, [])

    const className = name => `m2g-loyalty-burn-rules${name}`;

    if (!burnRules) return null;

    return (
        <div className={className('__container')}>
            <p className={className('__title')}>
                {t('how_it_works')}
            </p>
            {burnRules.map(rule =>
                <div
                    key={rule.id}
                    className={className('__rule')}
                >
                    {rule.summary}
                </div>)
            }
        </div>
    )
}

export default BurnRules;
